var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXeuWhitePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 4.13504C6 3.2872 6.98886 2.82405 7.64018 3.36682L17.0781 11.2318C17.5579 11.6316 17.5579 12.3684 17.0781 12.7682L7.64018 20.6332C6.98886 21.176 6 20.7128 6 19.865V4.13504Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXeuWhitePlay);
export default __webpack_public_path__ + "static/media/xeu-white-play.80c735c03bfe9a2cd5c5f2e3d3bc037f.svg";
export { ForwardRef as ReactComponent };